module.exports = __webpack_public_path__ + "img/furnishing.8cde62e3.png";